import { AddressDetail } from './address-detail';

export interface EntityEditRequest {
	address: AddressDetail;
	email: string;
	id: string;
	language: string;
	name: string;
	countryCode: string;
	phone: string;
	states: string[]; // Array of state ids
	timezone: string;
	fiscalMonthStart: number;
	operatingCountries: string[]; // Array of country names
	calendarStartDay: number; // 0 for Sunday, 1 for Monday, etc.
}
